import { addIcons } from 'ionicons';
import {
  // Core navigation icons
  homeOutline,
  appsOutline,
  settingsOutline,
  logOutOutline,
  menuOutline,
  closeOutline,
  close,
  
  // Arrow/Chevron icons
  arrowBackOutline,
  arrowForwardOutline,
  arrowForwardCircleOutline,
  chevronBackOutline,
  chevronForwardOutline,
  chevronDownOutline,
  chevronUpOutline,
  
  // Grid/List icons
  gridOutline,
  listOutline,
  
  // File/Folder icons
  fileTrayStackedOutline,
  folderOutline,
  folderOpenOutline,
  documentOutline,
  documentTextOutline,
  archiveOutline,
  downloadOutline,
  printOutline,
  cardOutline,
  
  // Status/Alert icons
  alertCircleOutline,
  alertCircle,
  checkmarkCircle,
  checkmarkCircleOutline,
  closeCircle,
  refreshOutline,

  // People/User icons
  peopleOutline,
  personOutline,
  personCircleOutline,
  
  // Communication icons
  mailOutline,
  callOutline,
  chatbubblesOutline,
  micOutline,
  
  // Form/Input icons
  searchOutline,
  addOutline,
  trashOutline,
  saveOutline,
  keyOutline,
  timeOutline,
  calendarOutline,
  createOutline,
  checkmarkOutline,

  // Device icons
  phonePortraitOutline,
  cameraOutline,
  
  // Misc icons
  flashOutline,
  checkboxOutline,
  cubeOutline,
  textOutline,
  shieldCheckmarkOutline,
  swapVerticalOutline,
  linkOutline,
  lockClosed,
  barChartOutline
} from 'ionicons/icons';

/**
 * Registers all Ionicons used throughout the application.
 * This should be called once during app initialization.
 */
export function registerIcons(): void {
  addIcons({
    // Core navigation icons
    homeOutline,
    appsOutline,
    settingsOutline,
    logOutOutline,
    menuOutline,
    closeOutline,
    close,
    
    // Arrow/Chevron icons
    arrowBackOutline,
    arrowForwardOutline,
    arrowForwardCircleOutline,
    chevronBackOutline,
    chevronForwardOutline,
    chevronDownOutline,
    chevronUpOutline,
    
    // Grid/List icons
    gridOutline,
    listOutline,
    
    // File/Folder icons
    fileTrayStackedOutline,
    folderOutline,
    folderOpenOutline,
    documentOutline,
    documentTextOutline,
    archiveOutline,
    downloadOutline,
    printOutline,
    cardOutline,
    
    // Status/Alert icons
    alertCircleOutline,
    alertCircle,
    checkmarkCircle,
    checkmarkCircleOutline,
    closeCircle,
    refreshOutline,

    // People/User icons
    peopleOutline,
    personOutline,
    personCircleOutline,
    
    // Communication icons
    mailOutline,
    callOutline,
    chatbubblesOutline,
    micOutline,
    
    // Form/Input icons
    searchOutline,
    addOutline,
    trashOutline,
    saveOutline,
    keyOutline,
    timeOutline,
    calendarOutline,
    createOutline,
    checkmarkOutline,

    // Device icons
    phonePortraitOutline,
    cameraOutline,
    
    // Misc icons
    flashOutline,
    checkboxOutline,
    cubeOutline,
    textOutline,
    shieldCheckmarkOutline,
    swapVerticalOutline,
    linkOutline,
    lockClosed,
    barChartOutline
  });
}
